const GET_CONFIGURATION_TYPE = '/open-periods/configuration-types';
const POST_CONFIGURATION_TYPE = '/open-periods-exams-level-code/search';
const POST_OPEN_PERIOD_CONFIG = '/open-periods/search';
const PUT_OPEN_PERIOD_CONFIG = '/open-periods';
const POST_WINDOW_PERIOD = '/open-periods/check-window-period/search';

const ROUTE = {
  GET_CONFIGURATION_TYPE,
  POST_CONFIGURATION_TYPE,
  PUT_OPEN_PERIOD_CONFIG,
  POST_OPEN_PERIOD_CONFIG,
  POST_WINDOW_PERIOD,
};

export {ROUTE};
